(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lb-faq"] && !Shopify.designMode) return;
  try {
    
(() => {
  const openQuestion = (hash, focus) => {
    if (!hash || hash === '#') return;
    let id;
    try {
      id = decodeURIComponent(hash.slice(1));
    } catch {
      return;
    }
    const question = document.getElementById(id);
    if (!question || !question.matches('details.lb-faq__item')) return;
    question.open = true;
    if (focus) question.querySelector('summary')?.focus({ preventScroll: true });
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('[data-lb-faq-link]');
    if (link) openQuestion(link.hash, true);
  });
  window.addEventListener('hashchange', () => openQuestion(window.location.hash, true));
  document.addEventListener('shopify:section:load', () => openQuestion(window.location.hash, false));
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches('details.lb-faq__item')) event.target.open = true;
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => openQuestion(window.location.hash, false), { once: true });
  } else {
    openQuestion(window.location.hash, false);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lb-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(scope) {
    scope.querySelectorAll('[data-lb-hero-video]').forEach((video) => {
      if (motion.matches) {
        video.pause();
        return;
      }
      video.muted = true;
      const playback = video.play();
      if (playback) playback.catch(() => {});
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  } else {
    initialize(document);
  }
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  motion.addEventListener('change', () => {
    if (motion.matches) document.querySelectorAll('[data-lb-hero-video]').forEach((video) => video.pause());
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
